import { useMutation, useQueryClient } from "@tanstack/react-query";
import { markInfractionOnboardingSeen } from "../services/infractions.service";
import type { UserProfileResponse } from "../types/infraction-api.types";
import { infractionQueryKeys } from "./infraction-query-keys";

export function useMarkInfractionOnboardingSeen() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: markInfractionOnboardingSeen,
		onSuccess: () => {
			queryClient.setQueryData<UserProfileResponse>(
				infractionQueryKeys.userProfile(),
				(previous) => {
					if (!previous) {
						return previous;
					}

					return {
						...previous,
						hasSeenInfractionOnboarding: true,
					};
				}
			);
		},
	});
}
